import { Fragment, h } from "preact";
import { useState } from "preact/hooks";

import {
	Box,
	Button,
	Checkbox,
	FormControl,
	FormControlLabel,
	Grid,
	MenuItem,

	Paper,
	Radio,
	RadioGroup,
	Stack,
	TextField,
	Tooltip,
	Typography,
} from "@mui/material";
import SellerByerOnboardingDialog from "../PopUps/SellerByerOnboardingDialog";
import WarningIcon from '@mui/icons-material/Warning';

export default function BuyerDetails({ state, handleChange, handleChangeCheckbox }) {
	const dutype = (id) => {
		if (id === 2) return "vendeur";
		if (id === 3) return "prospect";
		if (id === 4) return "acquéreur";
	};
	const [stateSellerByerOnboardingDialog, setStateSellerByerOnboardingDialog] = useState({
		open: false,
	});

	const handleCloseSellerByerOnboardingDialog = () => {
		setStateSellerByerOnboardingDialog({
			...stateSellerByerOnboardingDialog,
			open: false,
		});
	};
	const handleOpenSellerByerOnboardingDialog = () => {
		console.log("handleOpenSellerByerOnboardingDialog");
		setStateSellerByerOnboardingDialog({
			...stateSellerByerOnboardingDialog,
			open: true,
			users: state.siblings,
			uid: state.uid,
		});
	};

	return (
		<div>
			<SellerByerOnboardingDialog state={stateSellerByerOnboardingDialog} onClose={handleCloseSellerByerOnboardingDialog} />
			<Grid container spacing={2} alignItems="center">
				<Grid item xs={12}>
					<Typography variant="h5">Propriété du bien</Typography>

					{state.is_owner !== null && <FormControlLabel
						control={
							<Checkbox checked={state.is_owner} onChange={handleChangeCheckbox} name="is_owner" color="primary" disabled={state.ro} />
						}
						label="Je serai propriétaire du bien"
					/>}
					{state.is_owner === null && <Stack spacing={1}>
						<Typography>Serez-vous personnellement propriétaire du bien ?</Typography>
						<Box display={"flex"} justifyContent="flex-start">
							<Box p={1}><Button variant="contained" onClick={() => handleChange({ target: { name: "is_owner", value: false } })}>NON</Button></Box>
							<Box p={1}><Button variant="contained" onClick={() => handleChange({ target: { name: "is_owner", value: true } })}>OUI</Button></Box>
						</Box>
					</Stack>

					}
				</Grid>
				{state.is_owner && (
					<Grid item xs={12}>
						<Box display="flex" justifyContent="flex-start" alignItems="center">

							<Box p={1}>
								<TextField
									id="marital_status_id"
									name="marital_status_id"
									select
									label=""
									value={state.marital_status_id ? state.marital_status_id : "0"}
									onChange={handleChange}
									helperText=""
									variant="outlined"
									size="small"
									style="margin-right: 10px;"
									disabled={state.ro}
								>
									<MenuItem key={0} value={"0"}>
										<em>Choisir</em>
									</MenuItem>
									{state.marital_statuses.map((option) => (
										<MenuItem key={option.id} value={option.id}>
											{option.d}
										</MenuItem>
									))}
								</TextField>
							</Box>
							{!state.marital_status_id && (<Box p={1}>
								<Tooltip title="Ce champ est obligatoire"><WarningIcon color="primary" /></Tooltip>
							</Box>)}

						</Box>

						{state.marital_status_id == "2" && (
							<FormControl component="fieldset">
								<RadioGroup row aria-label="union" name="union" value={state.union} onChange={handleChange}>
									<FormControlLabel value={"O"} control={<Radio color="primary" />} label={`Avec un autre ${dutype(state.tp)}`} />
									<FormControlLabel
										value={"N"}
										control={<Radio color="primary" />}
										label={`Mon conjoint n'est pas concerné la transaction`}
									/>
								</RadioGroup>
							</FormControl>
						)}
					</Grid>
				)}{" "}
				{state.is_owner && state.union === "O" && (
					<Fragment>
						<Grid item xs={12} md={6}>
							{state.siblings.length > 0 && (
								<FormControl variant="outlined">
									<TextField
										name="has_union_with_id"
										select
										label=""
										value={state.has_union_with_id ? state.has_union_with_id : "0"}
										onChange={handleChange}
										helperText=""
										variant="outlined"
										size="small"
										style="margin-right: 10px;"
									>
										<MenuItem key={0} value={"0"}>
											<em>Le conjoint n'est pas encore dans la liste</em>
										</MenuItem>
										{state.siblings.map((s) => {
											return (
												<option value={s.uid}>
													<Typography variant="body1">{s.nm}</Typography>
												</option>
											);
										})}
									</TextField>
								</FormControl>
							)}
							{state.siblings.length == 0 && <Typography variant="body1">Il n'y a pas d'autre propriétaire</Typography>}
						</Grid>

						<Grid item xs={12} md={6}>
							{state.union === "O" && (state.has_union_with_id == "0" || state.has_union_with_id === null) && (
								<Button variant="outlined" onClick={handleOpenSellerByerOnboardingDialog}>
									Inviter mon/ma conjoint(e)
								</Button>
							)}
						</Grid>
					</Fragment>
				)}
				{state.proxied.length > 0 && <Grid item xs={12}>
					<Typography variant="h5">Représentation de personnes</Typography>
					{state.proxied.length == 0 && <Typography variant="body1">Vous ne représentez aucun acquéreur du dossier</Typography>}
					{state.proxied.length > 0 && <Typography variant="body1">Vous représentez:</Typography>}
					{state.proxied.map((prxd) => {
						return (
							<Paper style="padding: 10px; margin-top: 10px; max-width: 500px;">
								<Typography variant="body1">{prxd.n}</Typography>
							</Paper>
						);
					})}
				</Grid>}
				<Grid item xs={12}>
					{/* <Box display="flex" flexDirection="column" justifyContent="center" alignItems="flex-start">
						<Box>
							<Typography variant="h5">Mon notaire</Typography>
						</Box>
						<Box display="flex" flexDirection="column" justifyContent="space-between" alignItems="center">
							<Box>
								<FormControlLabel
									control={
										<Checkbox checked={state.notary_none} onChange={handleChangeCheckbox} name="notary_none" color="primary" />
									}
									label="Je n'ai pas de notaire"
								/>
							</Box>
						</Box>

					</Box> */}
				</Grid>
			</Grid>
		</div>
	);
}
